module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/2797c4d43d143f72e175168af370394f.png";